<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3>{{ _('Reports') }}</h3>
        </div>
      </div>
      <div class="row report-buttons">
        <div class="col-md-9">
          <button type="button" class="btn btn-primary" v-on:click="runReport('sales')"><i class="fa fa-fw fa-book"></i> {{ _('Daily sales') }}</button>
          <button type="button" class="btn btn-primary" v-on:click="runReport('payments')"><i class="fa fa-fw fa-book"></i> {{ _('Daily payments') }}</button>
          <button v-if="data && data.type === 'reservations'" type="button" class="btn btn-primary" v-on:click="runReport('dailyreservations')"><i class="fa fa-fw fa-book"></i> {{ _('Daily visitors') }}</button>
          <button v-else type="button" class="btn btn-primary" v-on:click="runReport('visitors')"><i class="fa fa-fw fa-book"></i> {{ _('Daily visitors') }}</button>
          <button class="btn btn-default" disabled="disabled" v-if="data && data.start && data.start !== 'today'">{{ DateTime.fromFormat(data.start, 'H:mm', { zone: timezone }).toFormat(timeFormat) }} - {{ DateTime.fromFormat(data.start, 'H:mm', { zone: timezone }).toFormat(timeFormat) }}</button>
        </div>
        <div class="col-md-3 text-right">
          <Dropdown buttonClass="btn-default" menuClass="dropdown-menu-right">
            <template #trigger>
              {{ selectedPosText }} &nbsp;<span class="caret"></span>
            </template>
            <li><a href="javascript:;" v-on:click="selectPos('this')"><span :class="'fa fa-fw ' + (selectedPos == 'this' ? 'fa-check' : '')"></span><span class="dropdown-text">{{ _('This point of use') }}</span></a></li>
            <li><a href="javascript:;" v-on:click="selectPos('all')"><span :class="'fa fa-fw ' + (selectedPos == 'all' ? 'fa-check' : '')"></span><span class="dropdown-text">{{ _('All points of use') }}</span></a></li>
          </Dropdown>
        </div>
      </div>
      <div :class="(isOdd(index) ? 'dark ' : '') + 'row report-row'" v-for="(report, index) in reports" v-on:click="openReport(report.id)">
        <div class="col-md-6">
          <strong>{{ report.title }}</strong>
        </div>
        <div class="col-md-3">
          {{ getReportTitle(report.type) }}
        </div>
        <div class="col-md-3">
          {{ DateTime.fromSeconds(Number(report.ts), { zone: timezone }).toFormat(dateFormat) }} {{ _('at') }} {{ DateTime.fromSeconds(Number(report.ts), { zone: timezone }).toFormat(timeFormat) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import { DateTime } from 'luxon'
import throttle from 'lodash/throttle'

export default {
  data () {
    return {
      DateTime: DateTime,
      requestId: false,
      reports: [],
      selectedPos: 'this'
    }
  },
  mixins: [components],
  computed: {
    data () {
      return JSON.parse(this.component.data)
    },
    start () {
      if (!this.data || !this.data.start || this.data.start === 'today') {
        return 'today'
      }
      const start = DateTime.fromFormat(this.data.start, 'H:mm', { zone: this.timezone })
      const now = DateTime.now({ zone: this.timezone })
      if (now > start) {
        return this.data.start
      } else {
        return 'yesterday ' + this.data.start
      }
    },
    end () {
      return this.start
    },
    selectedPosText () {
      if (this.selectedPos === 'this') {
        return this._('This point of use')
      }
      return this._('All points of use')
    }
  },
  methods: {
    selectPos (pos) {
      this.selectedPos = pos
    },
    isOdd (i) {
      return i % 2
    },
    getReportTitle (type) {
      let str = type
      switch(type) {
        case 'sales':
          str = this._('Sales report')
          break
        case 'payments':
          str = this._('Payments report')
          break
        case 'visitors':
        case 'dailyreservations':
          str = this._('Visitors report')
          break
      }
      return str
    },
    makeRequestId () {
      var ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      var ID_LENGTH = 8
      var rtn = ''
      for (var i = 0; i < ID_LENGTH; i++) {
        rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length))
      }
      this.requestId = rtn
    },
    runReport (type) {
      this.makeRequestId()
      let title = this._('Report')
      switch (type) {
        case 'sales':
          title = this._('Daily sales') + (this.selectedPos === 'this' ? ', ' + this._('Point of use') + ': ' + this.pos : '')
          break;
        case 'payments':
          title = this._('Daily payments') + (this.selectedPos === 'this' ? ', ' + this._('Point of use') + ': ' + this.pos : '')
          break;
        case 'visitors':
        case 'dailyreservations':
          title = this._('Daily visitors') + (this.selectedPos === 'this' ? ', ' + this._('Point of use') + ': ' + this.pos : '')
          break;
      }
      let obj = { 
        requestid: this.requestId,
        creator: this.user,
        type: type,
        title: title,
        time: 'now',
        start: this.start,
        end: this.end,
        format: 'html',
        output: 'download',
        email: '',
        categories: '',
        products: '',
        producttypes: '',
        resources: '',
        saleschannels: '',
        poses: this.selectedPos === 'this' ? [this.pos] : [],
        weekdays: '',
        days: '',
        months: '',
        enabled: 1
      }
      // let paramStr = Object.keys(obj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join('&');
      axios.post(this.baseDomain + this.shopId + '/scheduledreports.json?apikey=' + this.apiKey, obj)
    },
    openRef (ref) {
      window.open(this.baseDomain + ref.substring(1) + '?apikey=' + this.apiKey)
    },
    openReport (id) {
      window.open(this.baseDomain + this.shopId + '/archivedreports/' + id + '.html?apikey=' + this.apiKey)
    },
    loadReports () {
      axios.get(this.baseDomain + this.shopId + '/archivedreports.json?iSortingCols=1&iSortCol_0=0&sSortDir_0=desc&iDisplayStart=0&iDisplayLength=10&sSearch_3=sales,payments,visitors,dailyreservations&apikey=' + this.apiKey)
      .then(response => {
        this.reports = response.data
      })
      .catch(function () {
        console.log('Failed to load reports.')
      })
    },
    throttledReload: throttle(function () { this.loadReports() }, 1000, { leading: false, trailing: true })
  },
  mounted () {
    this.loadReports()
    if(!this.events) {
      let events = {}
      events['taskUpdate'] = (message) => {
        if (message && message.data && message.data.status === 'done') {
          if (message.data.requestid === this.requestId && message.data.ref) {
            this.openRef(message.data.ref)
          }
          return this.throttledReload()
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>
<style scoped>
.dark {
  background-color: #ECEFF1;
}
.report-buttons {
  margin-bottom: 10px;
}
.report-row {
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ced8dc;
}
</style>